;(function (angular, _) {
  'use strict'

  class EditSubcontractModalController {
    resolve = {}
    subcontractors = []

    constructor (
      // Angular
      // Libs
      // Managers
      EntityManager
      // Services
      // Const
      // Resolved
    ) {
      this.entityManager = EntityManager
    }

    $onInit () {
      this.searchSubcontractors()
    }

    addSubcontract () {
      if (!Array.isArray(this.resolve.line.subcontracts)) {
        this.resolve.line.subcontracts = []
      }
      this.resolve.line.subcontracts.push({ price: 0, directPayment: false, reverseCharge: false })
    }

    removeSubcontract (index) {
      this.resolve.line.subcontracts.splice(index, 1)
    }

    getMaxPrice (index) {
      return (this.resolve.line.subcontracts || []).reduce((acc, value, i) => {
        if (index === i) {
          return acc
        }
        return acc - value.price
      }, this.resolve.line.price.amount)
    }

    searchSubcontractors (search = '') {
      return this.entityManager.getType('EntitySubcontractor', null, search).then(({ data }) => {
        const usedIds = (this.resolve.line.subcontracts || []).map(({ entity }) => entity?._id)
        this.subcontractors = data.filter(({ _id }) => !usedIds.includes(_id))
      })
    }
  }

  EditSubcontractModalController.$inject = [
    // Angular
    // Libs
    // Managers
    'EntityManager'
    // Services
    // Const
    // Resolved
  ]

  angular.module('kilo.common.components')
    .component('editSubcontractModal', {
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      templateUrl: '/app/modules/compute/edit-subcontract-modal/edit-subcontract-modal.template.html',
      controller: EditSubcontractModalController
    })
})(window.angular, window._)
